import { useOAuthProviderError } from '../../../hooks/useOAuthProviderError';

export const OAuthErrorNotifier = (): null => {
  useOAuthProviderError();

  return null;
};
